import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import "./PdfViewerModal.scss";
import { Button } from "antd";
import CloseIcon from "../../../components/icons/CloseIcon";

const PdfViewerModal = ({ pdfData, isPdfOpen, closeModal }: any) => {
  const [isLoading, setIsLoading] = useState(true);

  const handleClose = () => {
    closeModal();
  };

  const handlePdfLoad = () => {
    setIsLoading(false);
  };

  return (
    <>
      <Modal
        style={{
          zIndex: "100000",
        }}
        show={isPdfOpen}
        onHide={handleClose}
        className="pdfviewer-modal"
        centered
      >
        <Modal.Header >
          <div className="flex items-center justify-between w-full">
            <p className="m-0">{pdfData.name}</p>
            <Button icon={<CloseIcon />} type="text" className="leading-[12px]" onClick={handleClose}/>
          </div>
        </Modal.Header>
        <Modal.Body>
          {isLoading && (
            <div className="body_spinner">
              <Spinner animation="border" variant="secondary" size="sm" />
            </div>
          )}
          <object
            style={{ width: "100%", height: "460px" }}
            data={pdfData.path}
            onLoad={handlePdfLoad}
          ></object>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PdfViewerModal;
